import "./AboutUs.css";
import { FaHandshake, FaSearch, FaLightbulb } from "react-icons/fa";
import ourMission from "../../assets/our-mission.jpg";
import founderImage1 from "../../assets/founder-img-1.jpg";
import founderImage2 from "../../assets/founder-img-2.jpg";
import FadeIn from "../../animations/components/FadeIn/FadeIn";
import SlideIn from "../../animations/components/SlideIn/SlideIn";
import ResponsiveContainer from "../../responsive/components/ResponsiveContainer/ResponsiveContainer";

export default function AboutUs() {
    return (
        <ResponsiveContainer>
            <section className="about ">
                <h1 className="about-title">About Us</h1>

                {/* Our Mission */}
                <FadeIn delay={0.4}>
                    <section className="about-section our-mission">
                        <div className="about-text">
                            <h2 className="about-section-title">
                                Our Mission: To Build a Safer, More Transparent Halal Industry
                            </h2>
                            <p>
                                Our mission is to empower <strong>consumers</strong> and <strong>businesses</strong>
                                with trust and confidence by ensuring full transparency in the
                                <strong> halal certification process</strong>. We strive to protect values,
                                promote integrity, and build a safer halal ecosystem for everyone.
                            </p>
                        </div>

                        <div className="about-image">
                            <img
                                src={ourMission}
                                alt="Illustration of our mission in the halal industry"
                                loading="lazy"
                            />
                        </div>
                    </section>
                </FadeIn>

                {/* Founder's Story */}
                <FadeIn delay={0.4}>
                    <section className="founder">
                        <div className="founder-text">
                            <h2>How and Why This Idea Came to Be</h2>
                            <p>
                                Inspired by the growing demand for <strong>trustworthy halal products</strong>,
                                our founder envisioned a platform that bridges the gap between producers,
                                certifiers, and consumers. With a strong background in technology and a
                                passion for ethical practices, this idea was born to simplify halal
                                verification and promote global trust.
                            </p>
                        </div>
                        <div className="founder-image-container">
                            <img
                                src={founderImage1}
                                alt="Founder portrait 1"
                                className="founder-image-1"
                                loading="lazy"
                            />
                            <img
                                src={founderImage2}
                                alt="Founder portrait 2"
                                className="founder-image-2"
                                loading="lazy"
                            />
                        </div>
                    </section>
                </FadeIn>

                {/* Our Values */}
                <section className="values-section">
                    <h2 className="about-section-title-values">Our Values</h2>
                    <div className="values-grid">
                        <SlideIn direction="up" delay={0.4}>
                            <article className="value-card"  >
                                <div className="icon-container">
                                    <FaHandshake className="icon" aria-hidden="true" />
                                </div>
                                <h3 className="value-card-title">Integrity</h3>
                                <p>We uphold the highest standards of honesty in everything we do.</p>
                            </article>
                        </SlideIn>

                        <SlideIn direction="up" delay={0.4}>
                            <article className="value-card" >
                                <div className="icon-container">
                                    <FaSearch className="icon" aria-hidden="true" />
                                </div>
                                <h3 className="value-card-title">Transparency</h3>
                                <p>We provide clear, accessible information at every step.</p>
                            </article>
                        </SlideIn>

                        <SlideIn direction="up" delay={0.4}>
                            <article className="value-card">
                                <div className="icon-container">
                                    <FaLightbulb className="icon" aria-hidden="true" />
                                </div>
                                <h3 className="value-card-title">Innovation</h3>
                                <p>We embrace technology to continuously improve halal verification.</p>
                            </article>
                        </SlideIn>
                    </div>
                </section>
            </section>
        </ResponsiveContainer>

    );
}
